/* eslint-disable react-hooks/exhaustive-deps */
import SyncIcon from "@mui/icons-material/Sync";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";

import DefaultApiService from "../../../../infrastructure/api/default";
import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import SingleLineDiagramDialog from "../../../components/graphical-view/SingleLineDiagramDialog";
import CustomMap from "../../../components/map/CustomMap";
import toMapMarkerData from "../../../components/map/mapMarkerUtils";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

const GVViewIndexPage = () => {
  const pageInfo = useGetPageInfo();
  const [data, setData] = useState({
    list: [],
    config: {
      center: [32.68, 51.68],
      zoom: 9,
      mapServiceKind: "Default",
    },
  });
  const [diagramDialog, setDiagramDialog] = useState({
    open: false,
    substationId: null,
  });

  const [loading, setLoading] = useState(false);
  // Neshan map key is loaded from backend settings via Map/Geocoding/GetClientConfig

  useEffect(() => {
    if (data.list.length === 0) onGetDataByFilter();
  }, []);

  const onGetDataByFilter = async () => {
    setLoading(true);
    const res = await DefaultApiService.getApi("GV/Map/GetData");
    // console.log("res", res);
    setLoading(false);
    setData(res.data);
  };

  const onSelectSubstationId = (substationId) => {
    setDiagramDialog({
      open: true,
      substationId,
    });
  };

  return (
    <Grid container spacing={3}>
      <SingleLineDiagramDialog
        open={diagramDialog.open}
        onClose={() => {
          setDiagramDialog({
            open: false,
            substationId: null,
          });
        }}
        substationId={diagramDialog.substationId}
      />

      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={() => onGetDataByFilter()}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12} sx={{ position: "relative" }}>
                <CustomMap
                  {...data.config}
                  loading={loading}
                  markers={toMapMarkerData(data.list, "دیاگرام تک خطی")}
                  onMarkerSelect={onSelectSubstationId}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default GVViewIndexPage;
